import React from 'react';
import { CommentListEventItem } from './CommentListEventItem';
import { Trans } from '@lingui/react/macro';
import { faUserTimes } from '@fortawesome/pro-light-svg-icons';
import { useIsSeller } from '@/utils/hooks';
import { CommentMessage } from '@ygtechnologies/bygr-frontend-chat';

interface Data {
    buyerName: string;
}

interface CommentListEventBuyerRemovedProps {
    comment: CommentMessage;
    isLastBuyer?: boolean;
}

export const CommentListEventBuyerRemoved = ({ comment, isLastBuyer }: CommentListEventBuyerRemovedProps) => {
    const isSeller = useIsSeller();
    const data: Data = comment.data;
    return (
        <CommentListEventItem
            icon={faUserTimes}
            title={<Trans>{data.buyerName} has been removed from the unit</Trans>}
            topText={isSeller && isLastBuyer ? <Trans>Messages sent before this is not visible to new buyers.</Trans> : ''}
        />
    );
};
